(ns app.front.view.group.admin.letter.bill-snippet-editor
  (:require [app.domain.fee.model :as fee-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(def bill-editor-data
  [{:title              :letter/unpaid-bill-snippet
    :placeholders       fee-model/shared-bill-template-variables
    :bill-fragment      :letter-fragment/unpaid-bill-snippet
    :fee-group-fragment :letter-fragment/unpaid-bill-fee-group-snippet
    :fee-item-fragment  :letter-fragment/unpaid-bill-fee-item-snippet}
   {:title              :letter/paid-bill-snippet
    :placeholders       fee-model/shared-receipt-template-variables
    :bill-fragment      :letter-fragment/paid-bill-snippet
    :fee-group-fragment :letter-fragment/paid-bill-fee-group-snippet
    :fee-item-fragment  :letter-fragment/paid-bill-fee-item-snippet}])

(defn bill-snippet-editor [{:keys [title
                                   placeholders
                                   bill-fragment
                                   fee-group-fragment
                                   fee-item-fragment]}
                           {:keys [get-external-edit-state-key
                                   tr
                                   images
                                   inherited?
                                   group-id
                                   document-id]}]
  [document-editor/editor
   (-> (util/mmap
         {:title              [:h4 (tr [title])]
          :read-only?         inherited?
          :placeholders       placeholders
          :small?             true
          :html-fragment-type bill-fragment}
         tr images group-id document-id)
       (text-editor/with-external-edit-state (get-external-edit-state-key bill-fragment)))
   [document-editor/editor
    (-> (util/mmap
          {:title              [:h4 (tr [:letter/bill-item-group-snippet])]
           :read-only?         inherited?
           :placeholders       fee-model/bill-group-snippet-variables
           :small?             true
           :html-fragment-type fee-group-fragment}
          tr images group-id document-id)
        (text-editor/with-external-edit-state (get-external-edit-state-key fee-group-fragment)))
    [document-editor/editor
     (-> (util/mmap
           {:title              [:h4 (tr [:letter/bill-item-snippet])]
            :read-only?         inherited?
            :placeholders       fee-model/bill-item-snippet-variables
            :small?             true
            :html-fragment-type fee-item-fragment}
           tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key fee-item-fragment)))]]])

(defn bill-snippets-editor [{:keys [visible-fragment-types] :as ctx}]
  (->> bill-editor-data
       (keep (fn [editor-data]
               (when (contains? visible-fragment-types (:bill-fragment editor-data))
                 [bill-snippet-editor editor-data ctx])))
       (into [:<>])))
